<div class="global-popup-wrapper" *ngIf="displayWidget">
  <div [ngClass]="{'reveal-overlay tpiq-reveal': currentView == 'maximized'}" (click)="resizeWindow('minimized')">
  </div>

  <div class="global-popup-window" [ngClass]="{'reveal tpiq-reveal': currentView == 'maximized' || currentView == 'smallscreen', 'show-global-popup-scrollBar': !showScrollBar}" [hidden]="currentView == 'minimized'"
       [ngStyle]="{'height': popupStyle.height, 'width': popupStyle.width, 'bottom': popupStyle.bottom, 'right': popupStyle.right,
             'top': popupStyle.top, 'border': 'none'}">
    <div class="row header d-flex align-items-center px-4" [ngStyle]="{'background-color': headerStyle.backgroundColor, 'color': headerStyle.color, 'padding': headerStyle.padding,
             'width': popupStyle.width}">
      <div class="medium-9 title" [innerHTML]="title | safeHtml" [ngStyle]="{'color': headerStyle.color, 'font-weight': 'bold'}"></div>
      <div class="medium-3 text-right">
        <i class="material-icons" (click)="resizeWindow('minimized')">remove</i>
        <i class="material-icons" style="padding: 0 5px;" (click)="toggleWindow()" *ngIf="!hideMaximize && currentView == 'smallscreen'">fullscreen</i>
        <i class="material-icons" style="padding: 0 5px;" (click)="toggleWindow()" *ngIf="!hideMaximize && currentView == 'maximized'">fullscreen_exit</i>
        <i class="material-icons" (click)="closeFloatingWindow()">close</i>
      </div>
    </div>
    <div class="row content pt-3">
      <div class="medium-12 columns" [ngClass]="{'no-padding': popupStyle.noPadding}">
        <router-outlet name="popup"></router-outlet>
      </div>
    </div>
  </div>

  <div class="row min-wall-add-task gradient-1" *ngIf="currentView == 'minimized'"
       [ngStyle]="{'bottom': minimizeStyle.bottom, 'right': minimizeStyle.right, 'top': minimizeStyle.top, 'background-color': headerStyle.backgroundColor}">
    <div class="small-6 medium-8 columns min-title" [innerHTML]="title | safeHtml"></div>
    <div class="minimizeTask small-6 medium-4 columns">
      <span (click)="resizeWindow('smallscreen')"><i class="material-icons min-task">keyboard_arrow_up</i></span>
      <span (click)="closeFloatingWindow()"><i class="material-icons min-close">clear</i></span>
    </div>
  </div>
</div>
